import { useCallback } from 'react';
import { getMetricDataSourcesQuery } from '@gonfalon/rest-api/queries/metricDataSource';
import { useQuery } from '@tanstack/react-query';

import { normalizeValueColumn } from './getMetricValueColumn';

export function useMetricDataSourceValueColumn(projectKey: string, enabled: boolean) {
  const { data } = useQuery({ ...getMetricDataSourcesQuery({ projKey: projectKey }), enabled });
  return useCallback(
    (dataSourceKey?: string) =>
      normalizeValueColumn(data?.items?.find((ds) => ds.key === dataSourceKey)?.columnMappings?.valueColumn),
    [data],
  );
}
